import React from "react";
import "../css/CertificateOfRegistration.scss";
import registrationCertificateWithSeal from "../../assets/images/Certificate of Registration with Seal NPC.svg";

function CertificateOfRegistration() {
  return (
    <div className="image-container">
      <img
        className="registration-seal"
        src={registrationCertificateWithSeal}
        alt="seal-of-registration"
      />
    </div>
  );
}

export default CertificateOfRegistration;
